import { createContext } from 'react'

interface AlertContextType {
  alert: AlertData
  showAlert: (newAlert: AlertData) => void
  clearAlert: () => void
}

enum AlertType {
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
}

interface AlertData {
  msg?: string
  severity?: AlertType
  duration?: number
}

const AlertContext = createContext<AlertContextType>({
  alert: {},
  showAlert: () => {},
  clearAlert: () => {},
})

export { AlertContext, AlertType }

export type { AlertContextType, AlertData }
